// The pages below `/settings/tags`: the list, one tag and its three sub pages.
export type TagsView =
  | { view: 'list' }
  | { view: 'tips' }
  | { view: 'tag'; id: number }
  | { view: 'aliases' | 'implied' | 'arrangement'; id: number }
  | { view: 'unknown' }

const SUB_PAGES = ['aliases', 'implied', 'arrangement'] as const

// `rest` is the route's `:rest*` parameter (what follows `/settings/tags/`): `[]`, `['5']` or `['5', 'aliases']`.
export function parseTagsPath(rest: string | string[] | undefined): TagsView {
  const parts = (Array.isArray(rest) ? rest : [rest ?? '']).filter((part) => part !== '')
  if (!parts.length) return { view: 'list' }
  if (parts.length === 1 && parts[0] === 'tips') return { view: 'tips' }
  if (!/^\d+$/.test(parts[0]) || parts.length > 2) return { view: 'unknown' }
  const id = Number(parts[0])
  if (parts.length === 1) return { view: 'tag', id }
  const sub = SUB_PAGES.find((name) => name === parts[1])
  return sub ? { view: sub, id } : { view: 'unknown' }
}

export function tagsPath(id?: number | 'tips', sub?: (typeof SUB_PAGES)[number]): string {
  return ['/settings/tags', id, sub].filter((part) => part !== undefined).join('/')
}

// Where Back goes from a page of the tags: one level up, the list goes to `/settings`.
export function tagsParent(view: TagsView): string {
  switch (view.view) {
    case 'list':
      return '/settings'
    case 'tips':
    case 'tag':
    case 'unknown':
      return tagsPath()
    default:
      return tagsPath(view.id)
  }
}
